

import React, { useCallback, useEffect, useMemo, useRef, useState} from 'react';
import { Form, Button, Modal } from 'react-bootstrap';

import "./index.scss";
import TableSkeleton from './TableSkeleton';
import { useCatalogueData } from './useCatalogHook';
import SelectedDataSet from './SelectedDataSet';
import CatalogueNotice from './CatalogueNotice';
import AddColumnsModal from './AddColumnsModal';
import { FaDownload, FaColumns, FaTimes, FaPen, FaPlus } from 'react-icons/fa';

// const LoaderPopup = () => (
//     <div className="tw-fixed tw-inset-0 tw-z-[120] tw-flex tw-items-center tw-justify-center tw-bg-white/70 tw-backdrop-blur">
//         <div className="tw-rounded-3xl tw-border tw-border-slate-200 tw-bg-white tw-p-6 tw-text-center tw-shadow-[0_25px_60px_rgba(15,23,42,0.2)]">
//             <div className="tw-mx-auto tw-h-12 tw-w-12 tw-rounded-full tw-border-4 tw-border-slate-200 tw-border-t-indigo-500 tw-animate-spin" />
//             <p className="tw-mt-3 tw-text-sm tw-font-semibold tw-text-slate-700">Exporting view…</p>
//         </div>
//     </div>
// );

// interface SelectedViewBadgeProps {  
//     viewName?: string;
// }
// const SelectedViewBadge: React.FC<SelectedViewBadgeProps> = ({ viewName }) => {
// if (!viewName) return null;

// return (
//     <div className="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-border-indigo-100 tw-bg-indigo-50 tw-px-3 tw-py-1 tw-text-sm tw-font-semibold tw-text-indigo-700">
//         <span role="img" aria-label="Selected view">🔖</span>
//         <span className="tw-max-w-[200px] tw-truncate">{viewName}</span>
//     </div>
// );
// };

const CustomTable = () => {

    const {
        data,
        columnsToShow,
        showModal,
        formattedString,
        visibleSelectedItems,
        bronzeDefaultFields,
        modalFormData,
        loading,
        columns,
        bronzeEditColumns,
        multipleSelection,
        selectedEndpoints,
        activeRelatedEntity,
        setActiveRelatedEntity,
        isRelatedEntityMode,
        selectedDataMarts,
        selectedDataMartEntities,
        relatedEntityColumns,
        relatedEntityData,
        relatedEntityLoading,
        dataMartEntityColumns,
        dataMartEntityData,
        dataMartEntityLoading,
        showErrorModal,
        currentPage,
        apiFailedStatus,
        setShowModal,
        setSelectedItems,
        handleSelect,
        handleInputChange,
        handleSave,
        handleDeleteCatalogColumn,
        canDeleteCurrentCatalogColumn,
        deletingCatalogColumn,
        refreshSourceEntityColumns,
        catalogModalMode,
        savingCatalogColumn,
        isInternalSourceEntitySelected,
        setData,
        setMultipleSelection,
        setSelectedEndpoints,
        setBronzeSelectionIdentity,
        setSelectedDataMarts,
        setSelectedDataMartEntities,
        setShowErrorModal,
        bronzeSelectionIdentity,
        downloadCSV,
        dataMartMappings,
        dataMartOptions,
        isLoadingDataMartMappings,
        isDataMartMode,
        silverFieldOptions,
        silverSelectedFields,
        toggleSilverFieldSelection,
        selectAllSilverFields,
        resetSilverFieldSelection,
        silverLockedFields,
        goldFieldOptions,
        goldSelectedFields,
        toggleGoldFieldSelection,
        selectAllGoldFields,
        resetGoldFieldSelection,
        goldLockedFields,
        handleEditClick
    } = useCatalogueData();

    const selectedItems = visibleSelectedItems;

    const [showFieldPanel, setShowFieldPanel] = useState(false);
    const [showAddColumnsModal, setShowAddColumnsModal] = useState(false);
    const [tableSearch, setTableSearch] = useState("");
    const [sortConfig, setSortConfig] = useState<{ field: string; direction: 'asc' | 'desc' } | null>(null);
    const [sidebarWidth, setSidebarWidth] = useState<number>(() => {
        const stored = window.localStorage.getItem("catalog-sidebar-width");
        const parsed = stored ? Number(stored) : 320;
        return Number.isFinite(parsed) ? parsed : 320;
    });
    const fieldPanelRef = useRef<HTMLDivElement | null>(null);
    const fieldButtonRef = useRef<HTMLButtonElement | null>(null);
    const resizingSidebarRef = useRef(false);
    const resizeStartXRef = useRef(0);
    const resizeStartWidthRef = useRef(320);
    const bronzeLockedFields = useMemo(
        () => new Set(['source_entity_column_name']),
        []
    );
    useEffect(() => {
        if (isDataMartMode) {
            setShowFieldPanel(false);
        }
    }, [isDataMartMode]);
    useEffect(() => {
        if (!showFieldPanel) {
            return undefined;
        }

        const handlePointerDown = (event: MouseEvent) => {
            const target = event.target as Node | null;
            if (!target) {
                return;
            }
            if (fieldPanelRef.current?.contains(target) || fieldButtonRef.current?.contains(target)) {
                return;
            }
            setShowFieldPanel(false);
        };

        document.addEventListener("mousedown", handlePointerDown);
        return () => document.removeEventListener("mousedown", handlePointerDown);
    }, [showFieldPanel]);
    useEffect(() => {
        window.localStorage.setItem("catalog-sidebar-width", String(sidebarWidth));
    }, [sidebarWidth]);
    useEffect(() => {
        const handlePointerMove = (event: MouseEvent) => {
            if (!resizingSidebarRef.current) {
                return;
            }
            const delta = event.clientX - resizeStartXRef.current;
            const nextWidth = Math.min(520, Math.max(280, resizeStartWidthRef.current + delta));
            setSidebarWidth(nextWidth);
        };
        const stopResizing = () => {
            resizingSidebarRef.current = false;
            document.body.style.cursor = "";
            document.body.style.userSelect = "";
        };

        document.addEventListener("mousemove", handlePointerMove);
        document.addEventListener("mouseup", stopResizing);
        return () => {
            document.removeEventListener("mousemove", handlePointerMove);
            document.removeEventListener("mouseup", stopResizing);
        };
    }, []);
    const handleSidebarResizeStart = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
        resizingSidebarRef.current = true;
        resizeStartXRef.current = event.clientX;
        resizeStartWidthRef.current = sidebarWidth;
        document.body.style.cursor = "col-resize";
        document.body.style.userSelect = "none";
    }, [sidebarWidth]);

    const silverDisplayColumns = useMemo(() => {
        if (!isRelatedEntityMode) {
            return null;
        }
        const availableFields = new Set(
            Array.isArray(relatedEntityColumns)
                ? relatedEntityColumns.map((column: any) => column.field)
                : []
        );
        return silverFieldOptions
            .filter(option => silverSelectedFields.includes(option.field))
            .filter(option => availableFields.size === 0 || availableFields.has(option.field))
            .map(option => ({ header: option.header, field: option.field }));
    }, [isRelatedEntityMode, relatedEntityColumns, silverFieldOptions, silverSelectedFields]);
    const goldDisplayColumns = useMemo(() => {
        if (!isDataMartMode) {
            return null;
        }
        if (!Array.isArray(dataMartEntityColumns)) {
            return dataMartEntityColumns;
        }
        const filtered = dataMartEntityColumns.filter((column: any) =>
            goldSelectedFields.includes(column.field)
        );
        return filtered.length > 0 ? filtered : dataMartEntityColumns;
    }, [isDataMartMode, dataMartEntityColumns, goldSelectedFields]);

    const fieldPanelItems = useMemo(() => {
        if (isRelatedEntityMode) {
            return silverFieldOptions;
        }
        if (isDataMartMode) {
            return goldFieldOptions;
        }
        return columns;
    }, [isRelatedEntityMode, isDataMartMode, silverFieldOptions, goldFieldOptions, columns]);
    const displayColumns = useMemo(() => {
        if (isRelatedEntityMode) {
            return silverDisplayColumns;
        }
        if (isDataMartMode) {
            return goldDisplayColumns;
        }
        return columnsToShow;
    }, [isRelatedEntityMode, silverDisplayColumns, isDataMartMode, goldDisplayColumns, columnsToShow]);

    const effectiveColumns = useMemo(() => {
        if (!displayColumns) {
            return displayColumns;
        }
        return displayColumns;
    }, [displayColumns]);
    useEffect(() => {
        if (!sortConfig || !Array.isArray(effectiveColumns)) {
            return;
        }
        const sortFieldStillVisible = effectiveColumns.some((column: any) => column.field === sortConfig.field);
        if (!sortFieldStillVisible) {
            setSortConfig(null);
        }
    }, [effectiveColumns, sortConfig]);
    const normalizedRelatedEntityData = useMemo(() => {
        if (!isRelatedEntityMode || !Array.isArray(relatedEntityData)) {
            return relatedEntityData;
        }
        return relatedEntityData.map(row => ({
            ...row,
            source_entity_column_name:
                row?.target_entity_rdv_column_name
        }));
    }, [isRelatedEntityMode, relatedEntityData]);

    const displayData = isRelatedEntityMode
        ? normalizedRelatedEntityData
        : isDataMartMode
            ? dataMartEntityData
            : data?.items ?? data?.data;
    const normalizedTableSearch = tableSearch.trim().toLowerCase();
    const filteredDisplayData = useMemo(() => {
        if (!Array.isArray(displayData)) {
            return displayData;
        }
        if (!normalizedTableSearch) {
            return displayData;
        }
        const searchableColumns = Array.isArray(effectiveColumns) ? effectiveColumns : [];
        return displayData.filter((row: any) =>
            searchableColumns.some((column: any) => {
                const rawValue = row?.[column.field];
                if (rawValue === null || rawValue === undefined) {
                    return false;
                }
                const normalizedValue =
                    typeof rawValue === "boolean"
                        ? (rawValue ? "true" : "false")
                        : String(rawValue).toLowerCase();
                return normalizedValue.includes(normalizedTableSearch);
            })
        );
    }, [displayData, effectiveColumns, normalizedTableSearch]);
    const sortedDisplayData = useMemo(() => {
        if (!Array.isArray(filteredDisplayData) || !sortConfig) {
            return filteredDisplayData;
        }

        const normalizeValue = (value: unknown) => {
            if (value === null || value === undefined || value === "") {
                return "";
            }
            if (typeof value === "boolean") {
                return value ? "true" : "false";
            }
            return String(value).toLowerCase();
        };

        return [...filteredDisplayData].sort((left: any, right: any) => {
            const leftValue = normalizeValue(left?.[sortConfig.field]);
            const rightValue = normalizeValue(right?.[sortConfig.field]);

            if (leftValue === rightValue) {
                return 0;
            }

            const result = leftValue < rightValue ? -1 : 1;
            return sortConfig.direction === 'asc' ? result : -result;
        });
    }, [filteredDisplayData, sortConfig]);
    const tableLoading = isRelatedEntityMode
        ? relatedEntityLoading
        : isDataMartMode
            ? dataMartEntityLoading
            : loading;
    const buildSchemaIdentifier = useCallback((sourceName: string) => {
        if (!sourceName) {
            return "";
        }

        const sanitized = sourceName
            .trim()
            .toLowerCase()
            .replace(/[^a-z0-9]+/gi, "_")
            .replace(/_{2,}/g, "_")
            .replace(/^_|_$/g, "");

        return `persistent_stage_${sanitized || "datasource"}`;
    }, []);

    const isFieldLocked = useCallback(
        (field: string) => {
            if (isRelatedEntityMode) {
                return silverLockedFields.has(field);
            }
            if (isDataMartMode) {
                return goldLockedFields.has(field);
            }
            return bronzeLockedFields.has(field);
        },
        [isRelatedEntityMode, isDataMartMode, silverLockedFields, goldLockedFields, bronzeLockedFields]
    );
    const configurableFieldPanelItems = useMemo(
        () => fieldPanelItems?.filter((item: any) => !isFieldLocked(item.field)) ?? [],
        [fieldPanelItems, isFieldLocked]
    );

    const isFieldChecked = useCallback(
        (field: string) => {
            if (isRelatedEntityMode) {
                return silverSelectedFields.includes(field);
            }
            if (isDataMartMode) {
                return goldSelectedFields.includes(field);
            }
            return selectedItems.includes(field);
        },
        [isRelatedEntityMode, isDataMartMode, silverSelectedFields, goldSelectedFields, selectedItems]
    );

    const handleFieldPanelItemToggle = useCallback(
        (item: any) => {
            if (isFieldLocked(item.field)) {
                return;
            }
            if (isRelatedEntityMode) {
                toggleSilverFieldSelection(item.field);
            } else if (isDataMartMode) {
                toggleGoldFieldSelection(item.field);
            } else {
                handleSelect(item);
            }
        },
        [handleSelect, isFieldLocked, isRelatedEntityMode, isDataMartMode, toggleSilverFieldSelection, toggleGoldFieldSelection]
    );
    const handleSelectAllFields = useCallback(() => {
        if (isRelatedEntityMode) {
            selectAllSilverFields();
            return;
        }
        if (isDataMartMode) {
            selectAllGoldFields();
            return;
        }
        const allBronzeFields = fieldPanelItems?.map((item: any) => item.field) ?? [];
        setSelectedItems(Array.from(new Set(allBronzeFields)));
    }, [
        isRelatedEntityMode,
        isDataMartMode,
        selectAllSilverFields,
        selectAllGoldFields,
        fieldPanelItems,
        setSelectedItems,
    ]);
    const handleResetFieldSelection = useCallback(() => {
        if (isRelatedEntityMode) {
            resetSilverFieldSelection();
            return;
        }
        if (isDataMartMode) {
            resetGoldFieldSelection();
            return;
        }
        setSelectedItems([...bronzeDefaultFields]);
    }, [
        isRelatedEntityMode,
        isDataMartMode,
        resetSilverFieldSelection,
        resetGoldFieldSelection,
        setSelectedItems,
        bronzeDefaultFields,
    ]);
    const handleSortColumn = useCallback((field: string) => {
        setSortConfig((current) => {
            if (!current || current.field !== field) {
                return { field, direction: 'asc' };
            }

            if (current.direction === 'asc') {
                return { field, direction: 'desc' };
            }

            return null;
        });
    }, []);

    const selectedSchemas = useMemo(() => {
        if (!Array.isArray(selectedEndpoints) || selectedEndpoints.length === 0) {
            return [];
        }

        const sources = Array.isArray(multipleSelection) ? multipleSelection : [];
        const schemaValues = sources
            .map(source => buildSchemaIdentifier(source))
            .filter(Boolean);

        return Array.from(new Set(schemaValues));
    }, [selectedEndpoints, multipleSelection, buildSchemaIdentifier]);
    const bronzeSelectionMeta = useMemo(() => {
        if ((isRelatedEntityMode || isDataMartMode) || !Array.isArray(displayData) || displayData.length === 0) {
            return null;
        }
        const firstRow = displayData[0] as any;
        return {
            sourceSchema: firstRow?.source_schema || null,
            sourceKind: firstRow?.source_entity_kind || null,
            sourceOrigin: firstRow?.source_entity_origin || null,
            dataSourceType: firstRow?.data_source_type || null,
        };
    }, [displayData, isRelatedEntityMode, isDataMartMode]);

    const summarizeChipValues = useCallback((values: string[]) => {
        if (!Array.isArray(values) || values.length === 0) {
            return "--";
        }

        if (values.length < 3) {
            return values.join(", ");
        }

        const [first, second] = values;
        const remainder = values.length - 2;
        return `${first}, ${second}${remainder > 0 ? ` +${remainder} more` : ""}`;
    }, []);

    const datasetSelectionChips = useMemo(
        () => [
            {
                key: "data-source",
                label: "Data source",
                values: Array.isArray(multipleSelection) ? multipleSelection : [],
            },
            {
                key: "schema",
                label: "Schema",
                values: bronzeSelectionMeta?.sourceSchema ? [bronzeSelectionMeta.sourceSchema] : selectedSchemas,
            },
            {
                key: "kind",
                label: "Kind",
                values: bronzeSelectionMeta?.sourceKind ? [bronzeSelectionMeta.sourceKind] : [],
            },
            {
                key: "origin",
                label: "Origin",
                values: bronzeSelectionMeta?.sourceOrigin ? [bronzeSelectionMeta.sourceOrigin] : [],
            },
            {
                key: "source-type",
                label: "Source type",
                values: bronzeSelectionMeta?.dataSourceType ? [bronzeSelectionMeta.dataSourceType] : [],
            }
        ],
        [multipleSelection, selectedSchemas, bronzeSelectionMeta]
    );

    const shouldShowSelectionChips = useMemo(() => {
        if (isRelatedEntityMode || isDataMartMode) {
            return false;
        }

        return datasetSelectionChips.some(entry => entry.values.length > 0);
    }, [datasetSelectionChips, isRelatedEntityMode, isDataMartMode]);
    const dataVaultChipEntries = useMemo(() => {
        if (!isRelatedEntityMode) {
            return [];
        }
        const dataSourceLabel = activeRelatedEntity?.data_source_name || "--";
        const sourceTableLabel = activeRelatedEntity?.source_entity_name || "--";
        const sourceSchemaValue =
            dataSourceLabel && dataSourceLabel !== "--"
                ? buildSchemaIdentifier(dataSourceLabel)
                : "--";

        return [
            { key: "dv-schema", label: "Data vault schema", value: "rdv" },
            { key: "dv-source", label: "Data source", value: dataSourceLabel || "--" },
            { key: "dv-source-schema", label: "Source schema", value: sourceSchemaValue },
            { key: "dv-source-table", label: "Source table", value: sourceTableLabel || "--" },
        ];
    }, [isRelatedEntityMode, activeRelatedEntity, buildSchemaIdentifier]);
    const dataMartEntityMeta = useMemo<Record<string, {
        tableConstruct?: string | null;
        dataMartSchema?: string | null;
        dataVaultSchema?: string | null;
        dataVaultEntity?: string | null;
    }>>(() => {
        if (!Array.isArray(dataMartMappings)) {
            return {};
        }
        return dataMartMappings.reduce((acc, item) => {
            const name = item?.target_entity_dm_name;
            if (name) {
                acc[name] = {
                    tableConstruct: item?.table_construct ?? item?.target_entity_table_construct ?? null,
                    dataMartSchema: item?.target_schema ?? null,
                    dataVaultSchema: item?.data_vault_schema ?? null,
                    dataVaultEntity: item?.target_entity_rdv_name ?? null,
                };
            }
            return acc;
        }, {} as Record<string, {
            tableConstruct?: string | null;
            dataMartSchema?: string | null;
            dataVaultSchema?: string | null;
            dataVaultEntity?: string | null;
        }>);
    }, [dataMartMappings]);
    const dataMartChipEntries = useMemo(() => {
        if (!isDataMartMode) {
            return [];
        }
        const entityValue = selectedDataMartEntities?.[0];
        if (!entityValue) {
            return [];
        }
        const metadata = dataMartEntityMeta[entityValue];
        if (!metadata) {
            return [];
        }
        return [
            {
                key: "dm-schema",
                label: "Data mart schema",
                value: metadata.dataMartSchema || "--",
            },
            {
                key: "dv-schema",
                label: "Data vault schema",
                value: metadata.dataVaultSchema || "--",
            },
            {
                key: "dv-entity",
                label: "Data vault entity",
                value: metadata.dataVaultEntity || "--",
            },
        ];
    }, [isDataMartMode, selectedDataMartEntities, dataMartEntityMeta]);

    const formatConstructDescriptor = useCallback((construct?: string | null) => {
        if (!construct) {
            return null;
        }
        const normalized = construct.toLowerCase();
        let entityType: string | null = null;
        if (normalized.startsWith("hub")) {
            entityType = "hub";
        } else if (normalized.startsWith("sat")) {
            entityType = "sat";
        } else if (normalized.startsWith("link")) {
            entityType = "link";
        }

        if (!entityType) {
            return null;
        }

        let persistenceLabel: string | null = null;
        if (normalized.includes("table")) {
            persistenceLabel = "persistent";
        } else if (normalized.includes("view")) {
            persistenceLabel = "virtualised";
        }

        return persistenceLabel ? `${entityType}, ${persistenceLabel}` : entityType;
    }, []);

    const selectedEntityHeading = useMemo(() => {
        if (isRelatedEntityMode) {
            const relatedName =
                activeRelatedEntity?.target_entity_rdv_name ||
                activeRelatedEntity?.source_entity_name;
            const constructSuffix = formatConstructDescriptor(activeRelatedEntity?.table_construct);
            if (relatedName && constructSuffix) {
                return `${relatedName} (${constructSuffix})`;
            }
            if (relatedName) {
                return relatedName;
            }
        }
        if (isDataMartMode) {
            const firstEntity = selectedDataMartEntities?.[0];
            if (firstEntity) {
                const construct = dataMartEntityMeta[firstEntity]?.tableConstruct;
                if (construct) {
                    return `${firstEntity} (${construct})`;
                }
                return firstEntity;
            }
        }
        if (selectedEndpoints?.length) {
            return selectedEndpoints.join(", ");
        }
        if (selectedDataMartEntities?.length) {
            return selectedDataMartEntities.join(", ");
        }
        if (multipleSelection?.length) {
            return multipleSelection.join(", ");
        }
        return "";
    }, [
        isRelatedEntityMode,
        activeRelatedEntity,
        formatConstructDescriptor,
        isDataMartMode,
        dataMartEntityMeta,
        selectedEndpoints,
        selectedDataMartEntities,
        multipleSelection,
    ]);
    const hasBronzeObjectSelection =
        Array.isArray(multipleSelection) &&
        multipleSelection.length > 0 &&
        Array.isArray(selectedEndpoints) &&
        selectedEndpoints.length > 0;
    const hasCatalogSelection = isRelatedEntityMode || isDataMartMode || hasBronzeObjectSelection;
    const sourceEntityLayerLabel = bronzeSelectionIdentity?.sourceEntityLayer
        ? bronzeSelectionIdentity.sourceEntityLayer.charAt(0).toUpperCase() + bronzeSelectionIdentity.sourceEntityLayer.slice(1)
        : "Bronze";
    const currentLayerLabel = isDataMartMode
        ? "Gold"
        : isRelatedEntityMode
            ? "Silver"
            : hasBronzeObjectSelection
                ? sourceEntityLayerLabel
                : "Catalog";
    const isSourceEntityMode = !isRelatedEntityMode && !isDataMartMode;
    const isBronzeMode = isSourceEntityMode;
    const modalColumns = isSourceEntityMode ? bronzeEditColumns : columnsToShow;
    const totalRowCount = isRelatedEntityMode
        ? relatedEntityData.length
        : isDataMartMode
            ? dataMartEntityData.length
            : Array.isArray(displayData)
                ? displayData.length
                : data?.total_count ?? data?.total ?? 0;
    const effectiveRowCount = Array.isArray(filteredDisplayData)
        ? filteredDisplayData.length
        : totalRowCount;
    const searchPlaceholder = isDataMartMode
        ? "Search DM column name, description, dimension flags..."
        : isRelatedEntityMode
            ? "Search RDV column name, description, business key, hash key..."
            : `Search ${bronzeSelectionIdentity?.sourceEntityLayer ?? "source"} column name, logical name, data type, description...`;
    const formatColumnHeader = useCallback(
        (header: string) =>
            !isRelatedEntityMode
                ? header
                : header.replace(/Target Entity Rdv\s*/gi, "").replace(/\s{2,}/g, " ").trim(),
        [isRelatedEntityMode]
    );
    // const handleRemoveFieldChip = (field: string) => {
    //     if (lockedFields.has(field)) {
    //         return;
    //     }
    //     const column = columns.find((col: any) => col.field === field) || { field };
    //     handleSelect(column);
    // };
    // const handleClearFieldSelection = () => {
    //     setSelectedItems([...alwaysSelectedItems]);
    // };
    // const handleRemoveFilterChip = (field: string) => {
    //     handleSelectForFilter(field);
    // };
    // const handleClearFilters = () => {
    //     setSelectedItemsForFilters([]);
    //     setFormFields([]);
    //     setFormattedString("");
    // };

    return (
        <>
            <div className="tw-h-[calc(100vh-3.5rem)] tw-overflow-hidden tw-bg-gradient-to-br tw-from-[#f7f9fc] tw-via-white tw-to-[#edf2ff] tw-text-slate-900">
                <div
                    className="tw-grid tw-h-full tw-gap-4 tw-p-4"
                    style={{ gridTemplateColumns: `${sidebarWidth}px 6px minmax(0,1fr)` }}
                >
                    <aside className="tw-overflow-hidden tw-rounded-[24px] tw-border tw-border-slate-200 tw-bg-white tw-p-3 tw-shadow-[0_10px_24px_rgba(15,23,42,0.06)]">
                        <div className="tw-border-b tw-border-slate-100 tw-px-2 tw-pb-3">
                            <p className="tw-text-xs tw-uppercase tw-tracking-[0.28em] tw-text-slate-500">Data Catalog</p>
                            <h1 className="tw-mt-1 tw-text-2xl tw-font-semibold tw-text-slate-900">Catalog Explorer</h1>
                        </div>
                        <div className="tw-mt-3 tw-h-[calc(100%-4.5rem)] tw-overflow-y-auto">
                            <SelectedDataSet
                                setData={setData}
                                selectedItems={selectedItems}
                                formattedString={formattedString}
                                multipleSelection={multipleSelection}
                                setMultipleSelection={setMultipleSelection}
                                selectedEndpoints={selectedEndpoints}
                                setSelectedEndpoints={setSelectedEndpoints}
                                setBronzeSelectionIdentity={setBronzeSelectionIdentity}
                                setShowErrorModal = {setShowErrorModal}
                                currentPage={currentPage}
                                dataMartMappings={dataMartMappings}
                                dataMartOptions={dataMartOptions}
                                selectedDataMarts={selectedDataMarts}
                                setSelectedDataMarts={setSelectedDataMarts}
                                selectedDataMartEntities={selectedDataMartEntities}
                                setSelectedDataMartEntities={setSelectedDataMartEntities}
                                isLoadingDataMartMappings={isLoadingDataMartMappings}
                                activeRelatedEntity={activeRelatedEntity}
                                setActiveRelatedEntity={setActiveRelatedEntity}
                            />
                        </div>
                    </aside>
                    <div
                        className="tw-relative tw-flex tw-items-stretch"
                        role="separator"
                        aria-orientation="vertical"
                        aria-label="Resize catalog explorer"
                    >
                        <button
                            className="tw-group tw-relative tw-h-full tw-w-full tw-cursor-col-resize tw-border-0 tw-bg-transparent tw-p-0 tw-outline-none"
                            onMouseDown={handleSidebarResizeStart}
                            aria-label="Resize catalog explorer"
                        >
                            <span className="tw-absolute tw-left-1/2 tw-top-0 tw-h-full tw-w-px -tw-translate-x-1/2 tw-bg-slate-200/70 tw-transition group-hover:tw-bg-slate-300" />
                            <span className="tw-absolute tw-left-1/2 tw-top-1/2 tw-h-16 tw-w-1 -tw-translate-x-1/2 -tw-translate-y-1/2 tw-rounded-full tw-bg-slate-300/70 tw-transition group-hover:tw-bg-slate-400" />
                        </button>
                    </div>

                    <main className="tw-flex tw-min-h-0 tw-flex-col">
                        <section className="tw-flex tw-min-h-0 tw-flex-1 tw-flex-col tw-rounded-[26px] tw-border tw-border-slate-200 tw-bg-white tw-p-2.5 tw-shadow-[0_12px_30px_rgba(15,23,42,0.06)]">
                            <div className="tw-flex tw-min-h-0 tw-flex-1 tw-flex-col tw-rounded-[20px] tw-border tw-border-slate-100 tw-bg-white">
                                <div className="tw-shrink-0 tw-border-b tw-border-slate-100 tw-px-3 tw-py-2.5">
                                    <div className="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-3">
                                        <div className="tw-min-w-[18rem] tw-flex-1">
                                            <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
                                                <span className="tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-slate-200 tw-bg-slate-50 tw-px-2.5 tw-py-0.5 tw-text-[11px] tw-font-semibold tw-uppercase tw-tracking-[0.2em] tw-text-slate-700">
                                                    {currentLayerLabel}
                                                </span>
                                                <h1 className="tw-text-[1.65rem] tw-font-semibold tw-leading-none tw-text-slate-900">
                                                    {hasCatalogSelection ? selectedEntityHeading || `${currentLayerLabel} catalog` : "Select a catalog object"}
                                                </h1>
                                                {hasCatalogSelection && (
                                                    <span className="tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-slate-200 tw-bg-white tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-text-slate-600">
                                                        {normalizedTableSearch
                                                            ? `${effectiveRowCount} of ${totalRowCount} rows`
                                                            : `${effectiveRowCount} row${effectiveRowCount === 1 ? "" : "s"}`}
                                                    </span>
                                                )}
                                            </div>
                                            {!hasCatalogSelection ? (
                                                <p className="tw-mt-2 tw-text-sm tw-text-slate-500">
                                                    Select one object in the explorer to load its column metadata.
                                                </p>
                                            ) : (
                                                <div className="tw-mt-2 tw-flex tw-flex-wrap tw-gap-2">
                                                    {isRelatedEntityMode ? (
                                                        dataVaultChipEntries.map(chip => (
                                                            <span key={chip.key} className="tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-slate-200 tw-bg-white tw-px-2.5 tw-py-1 tw-text-[11px] tw-font-medium tw-text-slate-600">
                                                                <span className="tw-mr-1.5 tw-uppercase tw-tracking-[0.14em] tw-text-slate-400">{chip.label}</span>
                                                                {chip.value || "--"}
                                                            </span>
                                                        ))
                                                    ) : isDataMartMode ? (
                                                        dataMartChipEntries.map(chip => (
                                                            <span key={chip.key} className="tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-slate-200 tw-bg-white tw-px-2.5 tw-py-1 tw-text-[11px] tw-font-medium tw-text-slate-600">
                                                                <span className="tw-mr-1.5 tw-uppercase tw-tracking-[0.14em] tw-text-slate-400">{chip.label}</span>
                                                                {chip.value || "--"}
                                                            </span>
                                                        ))
                                                    ) : shouldShowSelectionChips ? (
                                                        datasetSelectionChips.map(chip => (
                                                            <span key={chip.key} className="tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-slate-200 tw-bg-white tw-px-2.5 tw-py-1 tw-text-[11px] tw-font-medium tw-text-slate-600">
                                                                <span className="tw-mr-1.5 tw-uppercase tw-tracking-[0.14em] tw-text-slate-400">{chip.label}</span>
                                                                {summarizeChipValues(chip.values)}
                                                            </span>
                                                        ))
                                                    ) : null}
                                                </div>
                                            )}
                                        </div>
                                        <div className="tw-relative tw-flex tw-flex-wrap tw-items-center tw-gap-2">
                                            <div className="tw-min-w-[18rem] tw-flex-1">
                                                <input
                                                    type="text"
                                                    value={tableSearch}
                                                    onChange={(event) => setTableSearch(event.target.value)}
                                                    placeholder={searchPlaceholder}
                                                    disabled={!hasCatalogSelection}
                                                    className="tw-w-full tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-white tw-px-3.5 tw-py-2 tw-text-sm tw-text-slate-700 tw-outline-none tw-transition focus:tw-border-[#0a2f63]/40 focus:tw-ring-2 focus:tw-ring-[#0a2f63]/10"
                                                />
                                            </div>
                                        <button
                                            ref={fieldButtonRef}
                                            className="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-2xl tw-border tw-border-[#0a2f63] tw-bg-white tw-px-3.5 tw-py-2 tw-text-xs tw-font-semibold tw-text-[#0a2f63] tw-transition hover:tw-bg-[#0a2f63]/6"
                                            onClick={() => setShowFieldPanel((current) => !current)}
                                            disabled={!hasCatalogSelection}
                                        >
                                            <FaColumns /> Columns
                                        </button>
                                        {isSourceEntityMode && isInternalSourceEntitySelected && hasCatalogSelection && (
                                            <button
                                                className="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-2xl tw-border tw-border-emerald-700 tw-bg-white tw-px-3.5 tw-py-2 tw-text-xs tw-font-semibold tw-text-emerald-800 tw-transition hover:tw-bg-emerald-50"
                                                onClick={() => setShowAddColumnsModal(true)}
                                            >
                                                <FaPlus /> Add column
                                            </button>
                                        )}
                                        <button
                                            className="tw-flex tw-items-center tw-gap-2 tw-rounded-2xl tw-border tw-border-[#0a2f63] tw-bg-[#0a2f63] tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-transition hover:tw-bg-[#0b3a7a]"
                                            onClick={downloadCSV}
                                        >
                                            <FaDownload /> Export
                                        </button>
                                        {showFieldPanel && hasCatalogSelection && (
                                            <div
                                                ref={fieldPanelRef}
                                                className="tw-absolute tw-right-0 tw-top-[calc(100%+0.75rem)] tw-z-20 tw-w-[26rem] tw-max-w-[calc(100vw-3rem)] tw-rounded-[24px] tw-border tw-border-slate-200 tw-bg-white tw-p-4 tw-shadow-[0_20px_60px_rgba(15,23,42,0.18)]"
                                            >
                                                <div className="tw-flex tw-items-start tw-justify-between tw-gap-4">
                                                    <div>
                                                        <p className="tw-text-[11px] tw-uppercase tw-tracking-[0.24em] tw-text-slate-500">
                                                            Visible columns
                                                        </p>
                                                        <h3 className="tw-mt-1 tw-text-lg tw-font-semibold tw-text-slate-900">
                                                            Choose columns
                                                        </h3>
                                                    </div>
                                                    <button
                                                        className="tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-2xl tw-border tw-border-slate-200 tw-text-slate-500 tw-transition hover:tw-bg-slate-50 hover:tw-text-slate-700"
                                                        onClick={() => setShowFieldPanel(false)}
                                                        aria-label="Close columns"
                                                    >
                                                        <FaTimes />
                                                    </button>
                                                </div>

                                                <div className="tw-mt-4">
                                                    <div className="tw-flex tw-items-center tw-justify-between tw-gap-3">
                                                        <p className="tw-text-[11px] tw-uppercase tw-tracking-[0.2em] tw-text-slate-400">
                                                            Session columns
                                                        </p>
                                                        <div className="tw-flex tw-items-center tw-gap-3">
                                                            <button
                                                                className="tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-slate-200 tw-bg-slate-50 tw-px-3 tw-py-1.5 tw-text-xs tw-font-medium tw-text-slate-600 tw-transition hover:tw-border-slate-300 hover:tw-bg-white hover:tw-text-slate-800"
                                                                onClick={handleResetFieldSelection}
                                                            >
                                                                Use defaults
                                                            </button>
                                                            <button
                                                                className="tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-[#0a2f63]/20 tw-bg-[#0a2f63]/5 tw-px-3 tw-py-1.5 tw-text-xs tw-font-medium tw-text-[#0a2f63] tw-transition hover:tw-border-[#0a2f63]/30 hover:tw-bg-[#0a2f63]/10"
                                                                onClick={handleSelectAllFields}
                                                            >
                                                                Show all columns
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="tw-mt-2 tw-space-y-2 tw-max-h-[24rem] tw-overflow-y-auto tw-pr-1">
                                                        {configurableFieldPanelItems.map((item: any) => (
                                                            <label
                                                                key={item.field}
                                                                className="tw-flex tw-cursor-pointer tw-items-center tw-gap-3 tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-slate-50 tw-px-3 tw-py-2.5 tw-transition hover:tw-border-slate-300 hover:tw-bg-white"
                                                            >
                                                                <input
                                                                    type="checkbox"
                                                                    checked={isFieldChecked(item.field)}
                                                                    onChange={() => handleFieldPanelItemToggle(item)}
                                                                    className="tw-h-4 tw-w-4 tw-rounded tw-border-slate-300 tw-text-[#0a2f63] focus:tw-ring-[#0a2f63]"
                                                                />
                                                                <span className="tw-text-sm tw-font-medium tw-text-slate-700">
                                                                    {item.header}
                                                                </span>
                                                            </label>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                </div>
                                <div className="tw-flex-1 tw-overflow-hidden tw-rounded-[18px] tw-border tw-border-slate-100 tw-bg-white">
                                    {tableLoading ? (
                                        <TableSkeleton
                                            columns={
                                                effectiveColumns
                                                    ? effectiveColumns.length
                                                    : isRelatedEntityMode
                                                        ? silverSelectedFields.length
                                                        : isDataMartMode
                                                            ? goldSelectedFields.length
                                                            : selectedItems.length
                                            }
                                        />
                                    ) : (
                                        <>
                                            {!hasCatalogSelection ? (
                                                <div className="tw-flex tw-h-full tw-min-h-[24rem] tw-items-center tw-justify-center tw-p-8">
                                                    <div className="tw-max-w-xl tw-text-center">
                                                        <p className="tw-text-[11px] tw-uppercase tw-tracking-[0.26em] tw-text-slate-400">
                                                            No selection yet
                                                        </p>
                                                        <h3 className="tw-mt-3 tw-text-2xl tw-font-semibold tw-text-slate-900">
                                                            Select an object to view its columns
                                                        </h3>
                                                        <p className="tw-mt-3 tw-text-sm tw-leading-6 tw-text-slate-500">
                                                            Use the explorer on the left to choose one bronze source entity, one silver RDV entity, or one gold data mart entity. The table will then load the column metadata for that exact object.
                                                        </p>
                                                    </div>
                                                </div>
                                            ) : !apiFailedStatus ? (
                                                <div className="catalogue-table-shell">
                                                    {filteredDisplayData?.length > 0 ? (
                                                        <div className="catalogue-table-wrapper">
                                                            <table className="catalogue-table" role="table">
                                                                <thead>
                                                                    <tr>
                                                                        {effectiveColumns?.map((column: any, index: number) => (
                                                                            <th
                                                                                key={index}
                                                                                className={`catalogue-table__head ${index === 0 ? 'catalogue-table__head--sticky' : ''} ${sortConfig?.field === column.field ? 'catalogue-table__head--sorted' : ''}`}
                                                                            >
                                                                                <button
                                                                                    type="button"
                                                                                    className={`catalogue-table__sort-button ${sortConfig?.field === column.field ? 'is-active' : ''}`}
                                                                                    onClick={() => handleSortColumn(column.field)}
                                                                                >
                                                                                    <span>{formatColumnHeader(column.header)}</span>
                                                                                    <span className="catalogue-table__sort-indicator">
                                                                                        {sortConfig?.field === column.field
                                                                                            ? sortConfig.direction === 'asc'
                                                                                                ? '↑'
                                                                                                : '↓'
                                                                                            : '↕'}
                                                                                    </span>
                                                                                </button>
                                                                            </th>
                                                                        ))}
                                                                        {isBronzeMode && (
                                                                            <th className="catalogue-table__head catalogue-table__head--action">
                                                                                <span className="catalogue-table__head-label">Edit</span>
                                                                            </th>
                                                                        )}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {sortedDisplayData?.map((row: any, rowIndex: number) => (
                                                                        <tr key={rowIndex} className="catalogue-table__row">
                                                                            {effectiveColumns?.map((column: any, colIndex: number) => (
                                                                                <td
                                                                                    key={`${rowIndex}-${colIndex}`}
                                                                                    className={`catalogue-table__cell ${colIndex === 0 ? 'catalogue-table__cell--sticky' : ''}`}
                                                                                >
                                                                                    <div
                                                                                        className="catalogue-table__value"
                                                                                        title={
                                                                                            row[column.field] === null || row[column.field] === undefined
                                                                                                ? ""
                                                                                                : String(row[column.field])
                                                                                        }
                                                                                    >
                                                                                        {typeof row[column.field] === "boolean"
                                                                                            ? row[column.field] ? "True" : "False"
                                                                                            : row[column.field]}
                                                                                    </div>
                                                                                </td>
                                                                            ))}
                                                                            {isBronzeMode && (
                                                                                <td className="catalogue-table__cell catalogue-table__cell--action">
                                                                                    <button
                                                                                        type="button"
                                                                                        className="catalogue-table__action-btn"
                                                                                        onClick={() => handleEditClick(row)}
                                                                                        aria-label={`Edit metadata for ${row?.source_entity_column_name ?? "column"}`}
                                                                                        title="Edit metadata"
                                                                                    >
                                                                                        <FaPen />
                                                                                    </button>
                                                                                </td>
                                                                            )}
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    ) : (
                                                        <div className="tw-py-20 tw-text-center tw-text-slate-500">
                                                            {normalizedTableSearch
                                                                ? "No matching rows for the current search."
                                                                : isBronzeMode
                                                                    ? "No columns are registered for this source entity yet."
                                                                    : "No data exists to show for the current catalog selection."}
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                                <div className="tw-py-20 tw-text-center tw-text-slate-500">
                                                    Something went wrong, couldn't fetch catalog data
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                        </section>
                    </main>
                </div>
            </div>

            <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>{catalogModalMode === 'create' ? 'Add Column' : 'Edit Column Metadata'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                                {modalColumns?.map((column:any, index:any) => {
                                    if (column.header === "Source Entity Column Detail Id" || column.header === "Source Entity Column Id" || column.header === "Source Entity Column Details Id"){
                                        return null
                                    }else{
                                        const isReadOnlyField =
                                            (catalogModalMode !== 'create' && (
                                            column.field === "source_entity_column_name" ||
                                            column.field === "data_type")) ||
                                            column.field === "is_obsolete" ||
                                            column.field === "source_entity_name" ||
                                            column.field === "data_source_name";
                                        return(
                                        <Form.Group key={index} controlId={`form${column.field}`}>
                                            <Form.Label>{column.header}</Form.Label>
                                            
                                            {column.header === "Enable Genai" || column.header === "Pii" ?

                                            <Form.Check
                                            type="checkbox"
                                            name={column.field}
                                            checked={modalFormData[column.field]}
                                            onChange={handleInputChange}
                                            onClick={(e) => e.stopPropagation()}
                                            disabled={isReadOnlyField}
                                            />
                                            : 
                                            <Form.Control
                                                type="text"
                                                name={column.field}
                                                value={modalFormData ? modalFormData[column.field] : ''}
                                                onChange={handleInputChange}
                                                disabled={isReadOnlyField}
                                            /> }
                                            {isReadOnlyField && (
                                                <Form.Text className="text-muted">
                                                    System-owned field. Displayed for context only.
                                                </Form.Text>
                                            )}
                                        </Form.Group>
                                )}})}
                            </div>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        {canDeleteCurrentCatalogColumn && (
                            <Button
                                variant="outline-danger"
                                onClick={handleDeleteCatalogColumn}
                                disabled={deletingCatalogColumn}
                            >
                                {deletingCatalogColumn ? "Deleting..." : "Delete column"}
                            </Button>
                        )}
                        <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
                        <Button style={{background:"#293d57"}} onClick={handleSave} disabled={savingCatalogColumn}>
                            {savingCatalogColumn
                                ? (catalogModalMode === 'create' ? 'Creating...' : 'Saving...')
                                : (catalogModalMode === 'create' ? 'Create column' : 'Save changes')}
                        </Button>
                    </Modal.Footer>
                    </Modal>

            <AddColumnsModal
                show={showAddColumnsModal}
                onHide={() => setShowAddColumnsModal(false)}
                dataSourceId={bronzeSelectionIdentity?.dataSourceId ?? null}
                sourceEntityId={bronzeSelectionIdentity?.sourceEntityId ?? null}
                existingColumnNames={(displayData ?? [])
                    .map((row: any) => row?.source_entity_column_name)
                    .filter((name: any): name is string => typeof name === "string")}
                onCreated={() => {
                    const seId = bronzeSelectionIdentity?.sourceEntityId;
                    if (typeof seId === "number") {
                        void refreshSourceEntityColumns(seId);
                    }
                }}
            />
            <CatalogueNotice
                showModal={showErrorModal}
                setShowErrorModal = {setShowErrorModal}
            />

        </>
    );
};


export default CustomTable;
